import { inject, injectable } from "inversify";
import { DependencyType } from "@di/DependencyType";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import {
  CreateCropInput,
  CreateCropTypeDocument,
  CreateCropTypeMutation,
  CreateCropTypeMutationVariables,
  CropTypesDocument,
  CropTypesQuery,
  CropTypesQueryVariables,
} from "generated/graphql";

@injectable()
export class CropTypeService {
  constructor(
    @inject(DependencyType.ApolloClient)
    private readonly apolloClient: ApolloClient<NormalizedCacheObject>
  ) {}

  async findAll() {
    const queryTuple = await this.apolloClient.query<
      CropTypesQuery,
      CropTypesQueryVariables
    >({
      query: CropTypesDocument,
    });

    if (queryTuple.errors) {
      throw new Error(queryTuple.errors[0].message);
    }

    return queryTuple.data.cropTypes;
  }

  async create(input: CreateCropInput) {
    const mutationTuple = await this.apolloClient.mutate<
      CreateCropTypeMutation,
      CreateCropTypeMutationVariables
    >({
      mutation: CreateCropTypeDocument,
      variables: {
        input,
      },
      refetchQueries: [
        {
          query: CropTypesDocument,
        },
      ],
      awaitRefetchQueries: true,
    });

    if (mutationTuple.errors) {
      throw new Error(mutationTuple.errors[0].message);
    }

    return mutationTuple.data?.createCropType;
  }
}
